<template>
  <v-container class="pa-0">
    <v-row align="end">
      <v-col cols="12" sm="auto" align-self="end" class="py-sm-2 py-xs-1">
        <v-checkbox v-model="options.searchArchived" color="integrity" dense hide-details label="Search Archived Only" @change="update()" />
      </v-col>
      <!-- <v-col cols="12" sm="2" class="py-sm-2 py-xs-1">
        <v-select v-model="options.clientTypes" label="Client Type" dense hide-details :items="clientTypes" />
      </v-col>
      <v-col cols="12" sm="2" class="py-sm-2 py-xs-1">
        <v-select v-model="options.clientStatuses" label="Client Status" dense hide-details :items="clientStatuses" />
      </v-col>
      <v-col cols="12" sm="2" class="py-sm-2 py-xs-1">
        <v-select v-model="options.customerTypes" menu-props="auto, overflowY" label="Customer Type" dense hide-details :items="customerTypes" />
      </v-col> -->
    </v-row>
  </v-container>
</template>
<style scoped>
.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}
</style>
<script>
export default {
  name: 'AdvancedOptions',
  props: {
    divider: {
      type: Boolean
    },
    options: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      clientTypes: [
        { text: 'Customer', value: 256 },
        { text: 'Vendor', value: 512 },
        { text: 'Carrier', value: 1024 },
        { text: 'Personal Contact', value: 2048 },
        { text: 'Agent/Employee', value: 4096 },
        { text: 'Agency Contact', value: 8192 },
        { text: 'Emergency Contact', value: 32768 },
        { text: 'Other', value: 16384 }
      ],
      clientStatuses: [
        { text: 'Active', value: 1 },
        { text: 'Prospect', value: 8 },
        { text: 'Lead', value: 4 },
        { text: 'Dead File', value: 2 }
      ],
      customerTypes: [
        { text: 'Personal', value: 128 },
        { text: 'Commercial', value: 32 },
        { text: 'Life/Health', value: 64 },
        { text: 'Allow Cross Selling', value: 16 },
        { text: 'Do Not Market', value: 65536 }
      ]
    };
  },
  computed: {
    filtersActive: function () {
      return this.options.searchArchived ||
        ((this.options.clientTypes || null) != null && this.options.clientTypes.length > 0) ||
        ((this.options.clientStatuses || null) != null && this.options.clientStatuses.length > 0) ||
        ((this.options.customerTypes || null) != null && this.options.customerTypes.length > 0);
    }
  },
  methods: {
    update: function () {
      this.$emit('update');
    },
    clearFilters: function () {
      this.options.searchArchived = false;
      this.options.clientTypes = [];
      this.options.clientStatuses = [];
      this.options.customerTypes = [];
      this.update();
    }
  }
};

</script>
